import { useEffect, useRef, useState } from 'react';
import { AccessibilityInfo, Animated, StyleSheet, View, type StyleProp, type ViewStyle } from 'react-native';
import { colors, radii } from '~/ui/tokens';

export function SkeletonBlock({ style }: { style?: StyleProp<ViewStyle> }) {
  const travel = useRef(new Animated.Value(0)).current;
  const [blockWidth, setBlockWidth] = useState(320);

  useEffect(() => {
    let animation: Animated.CompositeAnimation | null = null;
    let mounted = true;
    void AccessibilityInfo.isReduceMotionEnabled().then((reduceMotion) => {
      if (!mounted || reduceMotion) return;
      animation = Animated.loop(Animated.timing(travel, { toValue: 1, duration: 1500, useNativeDriver: true }));
      animation.start();
    });
    return () => {
      mounted = false;
      animation?.stop();
    };
  }, [travel]);

  return <View accessibilityElementsHidden importantForAccessibility="no" style={[styles.block, style]} onLayout={(event) => setBlockWidth(event.nativeEvent.layout.width)}>
    <Animated.View style={[styles.shimmer, { transform: [{ translateX: travel.interpolate({ inputRange: [0, 1], outputRange: [-180, blockWidth + 180] }) }] }]} />
  </View>;
}

const styles = StyleSheet.create({
  block: {
    backgroundColor: colors.lineSoft,
    borderRadius: radii.sm,
    overflow: 'hidden',
  },
  shimmer: { position: 'absolute', top: 0, bottom: 0, width: 120, backgroundColor: 'rgba(255,255,255,0.48)', transform: [{ skewX: '-18deg' }] },
});
